import React from "react";
import { match } from "ts-pattern";
import { CaregiverUploadDocumentMobile } from "../../../messages";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import {
  CHECK_OUTLINED_ICON,
  INFO_OUTLINED_ICON,
  TIMES_OUTLINED_ICON,
} from "../../../utils/svgs_new";
import { AppCardContent } from "../../Generic/AppCard";
import ComplianceUploadCard from "./ComplianceUploadCard";
import styled from "@emotion/styled";
import { AppIcon } from "../../Generic/AppIcon";

interface Props {
  document: CaregiverUploadDocumentMobile;
  onClick: () => void;
}

function ComplianceDocumentCard(props: Props) {
  const color = match(props.document.status)
    .with("Rejected", () => "var(--red)")
    .with("Pending", () => "var(--orange)")
    .with("Approved", () => "var(--green)")
    .with("Dismissed", () => "var(--gray-400)")
    .exhaustive();

  const icon = match(props.document.status)
    .with("Rejected", () => TIMES_OUTLINED_ICON)
    .with("Pending", () => INFO_OUTLINED_ICON)
    .with("Approved", () => CHECK_OUTLINED_ICON)
    .with("Dismissed", () => TIMES_OUTLINED_ICON)
    .exhaustive();

  const statusLabel = match(props.document.status)
    .with("Rejected", () => translate(STRINGS.REJECTED))
    .with("Pending", () => translate(STRINGS.PENDING))
    .with("Approved", () => translate(STRINGS.APPROVED))
    .with("Dismissed", () => translate(STRINGS.DISMISSED))
    .exhaustive();

  const title = globalize().formatInstant(props.document.createdAt, { skeleton: "yMMMd" });

  const subTitle = (() => {
    if (props.document.status === "Rejected") {
      return `${translate(STRINGS.REJECTED)}: ${props.document.rejectReason}`;
    }

    return props.document.expiryDate === null
      ? translate(STRINGS.DOESNT_EXPIRE)
      : translate(STRINGS.EXPIRES_ON_DATE).replace(
          "%date%",
          globalize().formatLocalDate(props.document.expiryDate, { skeleton: "yMMMd" })
        );
  })();

  return (
    <ComplianceUploadCard.Styled onClick={props.onClick}>
      <ComplianceDocumentCard.wrapper>
        <AppIcon icon={icon} fill={color} stroke={color} size={24} />
        <ComplianceUploadCard.ContentWrapper>
          <ComplianceUploadCard.Title>{title}</ComplianceUploadCard.Title>
          <ComplianceUploadCard.Subtitle>
            {statusLabel} &bull; {subTitle}
          </ComplianceUploadCard.Subtitle>
        </ComplianceUploadCard.ContentWrapper>
      </ComplianceDocumentCard.wrapper>
    </ComplianceUploadCard.Styled>
  );
}

ComplianceDocumentCard.wrapper = styled(AppCardContent)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
  width: 100%;
`;

export default ComplianceDocumentCard;
